var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRetryCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2996 7.66598C11.9508 10.3269 9.67914 12.3142 6.99551 12.3061C4.31187 12.2981 2.05217 10.2973 1.7193 7.63434C1.38644 4.97142 3.08409 2.47591 5.68318 1.80754C8.28227 1.13918 10.9732 2.50615 11.9662 4.99931M12.2996 1.66598V4.99931L8.96622 4.99931",
    stroke: "#BA8D5B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetryCode);
export default __webpack_public_path__ + "static/media/retry-code.40ee5471971d60cd72ebcf3744f5aa3c.svg";
export { ForwardRef as ReactComponent };